/**
 * AppRouter — maps the current {@link RouteMatch} to a page component.
 *
 * Pages own their own Telegram Back/Main button wiring; this component is a thin
 * switch over the typed route union (exhaustive — TS enforces all cases).
 */
import { CheckoutPage } from "@pages/checkout";
import { HomePage } from "@pages/home";
import { NotFoundPage } from "@pages/not-found";
import { OrderPage } from "@pages/order";
import { OrdersPage } from "@pages/orders";
import { ProductPage } from "@pages/product";
import { ReferralsPage } from "@pages/referrals";
import {
  RpgBattlePage,
  RpgDevelopPage,
  RpgExchangePage,
  RpgFaqPage,
  RpgHubPage,
  RpgRatingsPage,
  RpgTransfersPage,
} from "@pages/rpg";
import { SettingsPage } from "@pages/settings";
import { ShopPage } from "@pages/shop";
import { SupportPage } from "@pages/support";
import { SupportTicketPage } from "@pages/support-ticket";
import { useRoute } from "@shared/router";

export function AppRouter(): JSX.Element {
  const route = useRoute();

  switch (route.name) {
    case "home":
      return <HomePage />;
    case "shop":
      return (
        <ShopPage
          {...(route.gameId !== undefined ? { gameId: route.gameId } : {})}
          {...(route.categoryId !== undefined
            ? { categoryId: route.categoryId }
            : {})}
        />
      );
    case "product":
      return <ProductPage productId={route.productId} />;
    case "checkout":
      return <CheckoutPage />;
    case "orders":
      return <OrdersPage />;
    case "order":
      return <OrderPage orderId={route.orderId} />;
    case "referrals":
      return <ReferralsPage />;
    case "earn":
      return <RpgHubPage />;
    case "rpg":
      return <RpgHubPage />;
    case "rpg-battle":
      return <RpgBattlePage />;
    case "rpg-develop":
      return (
        <RpgDevelopPage
          {...(route.tab !== undefined ? { initialTab: route.tab } : {})}
        />
      );
    case "rpg-ratings":
      return <RpgRatingsPage />;
    case "rpg-exchange":
      return <RpgExchangePage />;
    case "rpg-transfers":
      return <RpgTransfersPage />;
    case "rpg-faq":
      return <RpgFaqPage />;
    case "support":
      return <SupportPage />;
    case "support-ticket":
      return <SupportTicketPage ticketId={route.ticketId} />;
    case "settings":
      return <SettingsPage />;
    case "not-found":
      return <NotFoundPage />;
  }
}
